/**
 * UserCreatePage - Form for creating a new user (admin only).
 *
 * Route: /admin/users/new
 */

import { useNavigate } from '@tanstack/react-router'
import { UserForm } from '@/features/admin-users/components/UserForm'

export const Route = createFileRoute({
  component: UserCreatePage,
})

function UserCreatePage() {
  const navigate = useNavigate()

  const handleSuccess = () => {
    navigate({ to: '/admin/users' })
  }

  const handleCancel = () => {
    navigate({ to: '/admin/users' })
  }

  return (
    <UserForm
      mode="create"
      onSuccess={handleSuccess}
      onCancel={handleCancel}
    />
  )
}
